<div>
    <span class="k-icon k-i-html5"></span>
    <span class="optionversao">
        {{ customMsgService.translate('versaoWeb') }}: {{ versaoWeb.split('.').slice(0, -1).join('.')}}
    </span>
</div>
<div>
    <span class="k-icon k-i-cloud"></span>
    <span class="optionversao">
        {{ customMsgService.translate('versaoBackend') }}: {{ versaoBackend.split('.').slice(0, -1).join('.') }}
    </span>
</div>

